export enum SALES_FILTERS_NAME {
  PERIOD = "period",
  DISTRIBUTION = "distribution",
}
